import axiosInstance from "./api_helper";

const devisService = {
    list: async ({ clientId, chantierId, dateFrom, dateTo, query }) => {
        const params = {};
        if (clientId !== undefined && clientId !== null) params.clientId = clientId;
        if (chantierId !== undefined && chantierId !== null) params.chantierId = chantierId;
        if (dateFrom) params.dateFrom = dateFrom;
        if (dateTo) params.dateTo = dateTo;
        if (query) params.query = query;

        const response = await axiosInstance.get('/api/ventes/devis/list', { params });

        return response.data;
    },
    add: async (devisData) => {
        return await axiosInstance.post('/api/ventes/devis', devisData);
    },
    generatePdf : async (devisDTO) => {
        const response = await axiosInstance.post(`/api/devis/report`, devisDTO, {
            responseType: 'arraybuffer',
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return response.data;
    },
    accepterDevis: async (devisId) => {
        const response = await axiosInstance.post(`/api/ventes/devis/valider/${devisId}`);
        return response.data;
    },
    delete: async (devisId) => {
        const response = await axiosInstance.delete(`/api/ventes/devis/${devisId}`);
        return response.data;
    },
    
    filter: async (query) => {
        return axiosInstance.post(`/api/devis/search`, JSON.stringify(query));
    },
    
    fetchNewDevisNumber : async () => {
        return axiosInstance.get(`/api/devis/new-devis-number`);
    },
    
    updateDevis: async (devisId, devisData) => {
        return await axiosInstance.put(`/api/ventes/devis/${devisId}`, JSON.stringify(devisData));
    },
}

export default devisService;